import SinglePriceChart from './SinglePriceChart';

export default SinglePriceChart;
